import { useEffect } from 'react';
import { toast } from 'react-toastify';
import {
  getImages,
  getThemeVersionConfig,
  getThemeVersions,
} from '../functions/API';
import { LauncherVersionData } from '../types/hooks';
import { useEditor } from './useEditor';
import { useScene } from './useScene';

export const sceneHooks = () => {
  const { userSession, launcherThemeSession, setLauncherThemeSession } =
    useEditor();
  const scene = useScene();

  const loadThemeData = async ({
    themeID,
    versionID,
  }: {
    themeID: string;
    versionID: string | null;
  }) => {
    const versions = (await getThemeVersions({ themeID })) || [];
    const sortedVersions = versions?.sort(
      (a: LauncherVersionData, b: LauncherVersionData) =>
        Date.parse(b.createdAt) - Date.parse(a.createdAt)
    );
    const images = (await getImages({ themeID })) || [];
    !versionID ? (versionID = sortedVersions[0]?.id) : null;
    const themeConfig = versionID
      ? await getThemeVersionConfig({ themeID, versionID })
      : null;

    return { versions: sortedVersions, images, themeConfig, versionID };
  };

  // Load theme data after log in
  useEffect(() => {
    (async () => {
      const shouldLoadTheme =
        userSession.isLoggedIn && userSession.isAuthorized;

      const themeID = launcherThemeSession.themeID;
      const versionID = launcherThemeSession.versionID;

      if (!themeID) {
        if (shouldLoadTheme === false) {
          scene.loadDemoTheme();
          setLauncherThemeSession((themeData) => ({
            ...themeData,
            isThemeLoaded: true,
          }));
        }
        return;
      }

      if (shouldLoadTheme) {
        const themeDataPromise = loadThemeData({ themeID, versionID });

        const {
          versions,
          images,
          themeConfig,
          versionID: verifiedVersionID,
        } = await toast.promise(themeDataPromise, {
          pending: 'Loading the theme data',
          success: 'The theme data has been loaded',
          error: 'Error while loading the theme data',
        });

        setLauncherThemeSession((themeData) => ({
          ...themeData,
          isThemeLoaded: true,
          versions,
          images,
          versionID: verifiedVersionID,
        }));

        if (themeConfig) {
          scene.importLauncherConfigJSON(themeConfig);
        } else {
          // scene.newTheme();
          scene.loadDemoTheme();
        }
      }
    })();
  }, [userSession]);
};
